var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26584_4591)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.15406 8.35547L5.46656 13.3555L6.22094 12.6455L1.81156 8.50047L17 8.50047V7.50047L1.81156 7.50047L6.21562 3.35547L5.46656 2.65047L0.15406 7.65047C0.0551147 7.74415 -0.000423431 7.87088 -0.000423431 8.00297C-0.000423431 8.13506 0.0551147 8.26179 0.15406 8.35547Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26584_4591"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 16,
    fill: "white",
    transform: "matrix(-1 0 0 -1 17 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back-arrow.f03475d60a7a89d02c2694e56fd672c5.svg";
export { ForwardRef as ReactComponent };